<template>
  <v-progress-circular
    :size="70"
    :width="7"
    color="primary"
    indeterminate
  />
</template>


<script>
export default {
  name: 'LoadingIcon'
}
</script>



// WEBPACK FOOTER //
// src/components/utils/LoadingIcon.vue